module.exports = __webpack_public_path__ + "tmp_node_modules/@fancyapps/ui/dist/fancybox/.css.liquid";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fancyapps/ui/dist/fancybox/fancybox.css
// module id = 517
// module chunks = 0